import React, { useEffect, useRef } from "react";
import Styles from "../../assets/css/PageNotFound/SoonPage.module.css";
import { useGlobalState } from "../../Functions/GlobalStates"; // Import the custom hook
import debounce from "lodash.debounce";
import { Helmet } from "react-helmet-async";

const SoonPage = () => {
  // Global States Here //////////////////////////////////////////////////////...............................
  const { setCheckPage, setDontAllow, PagesWidthHeight, setPagesWidthHeight } =
    useGlobalState();
  // React Elements References Here //////////////////////////////////// ...............
  const SoonPage = useRef(false); // Ref for the absolute box
  const CheckPageStateRef = useRef(false); // Ref for the check Page

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (SoonPage.current) {
        const { width, height } = SoonPage.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Coming Soon – Affiliators 🚀</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Something exciting is on the way! Stay tuned for new updates and offerings from Affiliators."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="coming soon, new updates, upcoming features, Affiliators launch"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Coming Soon – Affiliators 🚀" />
        <meta
          property="og:description"
          content="We are working on something exciting. Stay tuned for what's coming soon!"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/comingsoon"
        />

        {/* Image Meta Tags for Social Sharing */}
        {/*
  <meta
    property="og:image"
    content="/images/comingsoon/comingsoon.png"
  />
  <meta
    name="twitter:image"
    content="/images/comingsoon/comingsoon.png"
  />
  */}

        {/* Twitter Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Coming Soon – Affiliators 🚀" />
        <meta
          name="twitter:description"
          content="Something exciting is on the way. Stay tuned for updates!"
        />

        {/* Indexing and Canonical URL */}
        <meta name="robots" content="index, follow" />
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/comingsoon"
        /> */}

        {/* Author and Language */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta httpEquiv="Content-Language" content="en" />
      </Helmet>

      <div ref={SoonPage} className={Styles.SoonPageContainer}>
        <h1>Soon This Page Will Be Completed & Become Live To You👍😘</h1>
        <span></span>
      </div>
    </>
  );
};

export default SoonPage;
